import debounce from "lodash/debounce";
import cleansePositiveNumber from '../../../modules/cleansePositiveNumber';
import GetManufacturerFromBrand from "../../../used-vue/api/GetManufacturerFromBrand";
import getFinanceNameFromKey from "../../../new-vue/api/finance/GetFinanceNameFromKey";
import NumberFormat from "../../../used-vue/api/NumberFormat";
import { getFromStorage, saveToStorage } from '../../../used-vue/api/Storage';

const numberOfPayments = function(financeProduct) {
    let numberOfPayments = 0;
    if (typeof financeProduct.Quote.Payments == 'undefined') {
        return numberOfPayments;
    }

    let paymentsLength = financeProduct.Quote.Payments.length;
    if (paymentsLength == 0) {
        return numberOfPayments;
    }

    financeProduct.Quote.Payments.forEach((element, index) => {
        if (typeof element.NumberOfPayments == 'undefined') {
            return;
        }
        numberOfPayments = numberOfPayments + parseInt(element.NumberOfPayments);
    });

    return numberOfPayments;
};

const getDepositContribution = function(financeProductResult) {
    let depCon = 0.00;

    if (typeof financeProductResult.Quote.DepositContributions !== 'undefined') {
        financeProductResult.Quote.DepositContributions.forEach(element => {
            if (typeof element.Amount !== 'undefined' && element.Amount > 0) {
                depCon = depCon + parseFloat(element.Amount);
            }
        });
        return depCon;
    }

    if (typeof financeProductResult.Notifications.Public !== 'undefined') {
        financeProductResult.Notifications.Public.forEach(financeNotification => {
            if (financeNotification.Code == "9" && financeNotification.Value > 0) {
                depCon = depCon + financeNotification.Value;
            }
        });
        return depCon;
    }

    return depCon;
};

const getDepositContributionExcludingDealer = function(quote) {
    let depCon = 0.0;

    if (typeof quote.Quote.DepositContributions !== 'undefined') {
        quote.Quote.DepositContributions.forEach(element => {
            if (typeof element.Name !== 'undefined' && element.Name == 'Dealer Contribution') {
                return;
            }
            if (typeof element.Amount !== 'undefined' && element.Amount > 0) {
                depCon = depCon + parseFloat(element.Amount);
            }
        });
        return depCon;
    }

    if (typeof quote.Notifications.Public !== 'undefined') {
        quote.Notifications.Public.forEach(financeNotification => {
            if (financeNotification.Code == "9" && financeNotification.Value > 0) {
                depCon = depCon + parseFloat(financeNotification.Value);
            }
        });
        return depCon;
    }

    if (typeof quote.Quote.DepositContribution !== 'undefined') {
        return parseFloat(quote.Quote.DepositContribution);
    }

    return depCon;
};

const getDealerDepositContribution = function(quote) {
    let depCon = 0;

    if (typeof quote.Quote.DepositContributions !== 'undefined') {
        quote.Quote.DepositContributions.forEach(element => {
            if (typeof element.Name == 'undefined' || element.Name != 'Dealer Contribution') {
                return;
            }
            if (typeof element.Amount !== 'undefined' && element.Amount > 0) {
                depCon = depCon + parseFloat(element.Amount);
            }
        });
        return depCon;
    }

    return 0;
};

const getGovernmentGrant = function(quote) {
    if (typeof quote.CashPriceDiscounts == 'undefined' || quote.CashPriceDiscounts.length == 0) {
        return 0;
    }
    let governmentGrant = 0;
    for (let i = 0, len = quote.CashPriceDiscounts.length; i < len; i++) {
        if (quote.CashPriceDiscounts[i].Name && quote.CashPriceDiscounts[i].Name == 'Government Grant') {
            governmentGrant += quote.CashPriceDiscounts[i].Amount;
        }
    }

    return governmentGrant;
};

/**
 * Append vehicle pricing including applicable grants
 * @param {Object} rootState
 * @param {Array} outputArray
 * @param {Object} quote
 * @returns Array
 */
const appendVehiclePricingIncludingApplicableGrants = function(rootState, outputArray, quote) {
    const totalVehiclePrice = Number(rootState.selectedVehiclePrice) + Number(rootState.selectedPaintPrice) + Number(rootState.selectedInteriorPrice)
    const cashPrice = Number((quote.CashPrice || totalVehiclePrice));
    const grant = getGovernmentGrant(quote);

    if (totalVehiclePrice !== cashPrice) {
        outputArray.push({
            title: 'Vehicle Price (OTR)',
            value: '&pound;' + NumberFormat(totalVehiclePrice, 2)
        });

        if (grant > 0) {
            outputArray.push({
                title: 'Government Grant',
                value: '&pound;' + NumberFormat(grant, 2)
            });
        }

        outputArray.push({
            title: 'Vehicle Selling Price',
            value: '&pound;' + NumberFormat(cashPrice, 2)
        });
    } else if (grant > 0 && totalVehiclePrice == cashPrice) {
        outputArray.push({
            title: 'Vehicle Price (OTR)',
            value: '&pound;' + NumberFormat(totalVehiclePrice + grant, 2)
        });

        outputArray.push({
            title: 'Government Grant',
            value: '&pound;' + NumberFormat(grant, 2)
        });

        outputArray.push({
            title: 'Vehicle Selling Price',
            value: '&pound;' + NumberFormat(cashPrice, 2)
        });
    } else {
        outputArray.push({
            title: 'Vehicle Price',
            value: '&pound;' + NumberFormat(cashPrice, 2)
        });
    }

    return outputArray;
};

const getFinalPayment = function(quote) {
    if (typeof quote.FinalPayment !== 'undefined') {
        return quote.FinalPayment;
    }

    if (typeof quote.Payments == 'undefined') {
        return 0.00;
    }

    let paymentsLength = quote.Payments.length;
    if (paymentsLength == 0) {
        return 0.00;
    }

    let lastPayment = quote.Payments[paymentsLength - 1];
    if (typeof lastPayment.NumberOfPayments == 'undefined' || lastPayment.NumberOfPayments > 1) {
        return 0.00;
    }
    if (typeof lastPayment.Amount == 'undefined') {
        return 0.00;
    }

    return lastPayment.Amount;
};

const getFirstFee = function (quote) {
    if (typeof quote.Fees == 'undefined') {
        return 0.00;
    }

    if (quote.Fees.length == 0) {
        return 0.00;
    }

    const firstFee = quote.Fees[0];
    if (typeof firstFee.Amount == 'undefined') {
        return 0.00;
    }

    return parseFloat(firstFee.Amount);
};

const getRoadsideAssistance = function (quote) {
    if (typeof quote.Breakdown == 'undefined' || quote.Breakdown.length == 0) {
        return 0;
    }

    let roadsideAssistance = 0;
    for (let i = 0, len = quote.Breakdown.length; i < len; i++) {
        if (quote.Breakdown[i].Type && quote.Breakdown[i].Type == 'Roadside Assistance') {
            roadsideAssistance += quote.Breakdown[i].Amount;
        }
    }

    return roadsideAssistance;
};

const state = {
    term: 48,
    deposit: 2315,
    mileage: 10000,
    modified: false,
    initialized: false,
    financeLoading: true,
    financeAvailable: null,
    quotes: null,
    financeType: null,
    monthlyPayment: null,
    numberOfPayments: null,
    selectedDealerCodewaversKey: null,
    pcpQuote: null,
    hpQuote: null,
};

const getters = {
    modified(state) {
        return state.modified;
    },
};

const actions = {
    initialize({ commit, state }) {
        if (state.initialized) {
            return;
        }
        commit('setFinanceTerm', cleansePositiveNumber(getFromStorage('new_term'), 48));
        commit('setFinanceDeposit', cleansePositiveNumber(getFromStorage('new_deposit'), 2315));
        commit('setFinanceMileage', cleansePositiveNumber(getFromStorage('new_mileage'), 10000));
    },
    getFinance:
        debounce(({ commit, dispatch, rootState, state }) => {
            commit('setFinanceLoading', true);
            return new Promise((resolve, reject) => {
                const pcpRequest = JSON.parse(JSON.stringify(rootState.pcpVehicleRequest));
                const hpQuote = JSON.parse(JSON.stringify(rootState.hpVehicleRequest));
                // if (state.selectedDealerCodewaversKey != null) {

                // }
                axios
                    .post("https://services.codeweavers.net/public/v3/jsonfinance/calculate", {
                        Credentials: {
                            ApiKey: "ONH75GHd8x0gu6yfJ6",
                        },
                        Customer: {
                            Reference: "",
                        },
                        Parameters: {
                            Term: state.term,
                            Deposit: state.deposit,
                            DepositType: "Amount",
                            AnnualMileage: state.mileage,
                        },
                        VehicleRequests: [pcpRequest, hpQuote],
                    })
                    .then(response => {
                        commit('setQuotes', response.data.VehicleResults);
                        dispatch('findCheapestQuote');
                        dispatch('setPcpQuote');
                        dispatch('setHpQuote');
                        commit('setFinanceLoading', false);
                        resolve(response.data.VehicleResults);
                    })
                    .catch(error => {
                        commit('setFinanceLoading', false);
                        console.error("getFinance error");
                        console.error(error);
                        reject(error);
                    });
            });
        },
        350,
        {
            leading: true,
            trailing: true
        }
    ),
    getFinanceQuoteForDealership({ rootState, state }, key) {
        return new Promise((resolve, reject) => {
            let request;
            if (key == 'PCP') {
                request = JSON.parse(JSON.stringify(rootState.pcpVehicleRequest));
            } else {
                request = JSON.parse(JSON.stringify(rootState.hpVehicleRequest));
            }
            if (state.selectedDealerCodewaversKey != null) {
                request.Dealer = state.selectedDealerCodewaversKey
            }
            axios
                .post("https://services.codeweavers.net/public/v3/jsonfinance/calculate", {
                    Credentials: {
                        ApiKey: "ONH75GHd8x0gu6yfJ6",
                    },
                    Customer: {
                        Reference: "",
                    },
                    Parameters: {
                        Term: state.term,
                        Deposit: state.deposit,
                        DepositType: "Amount",
                        AnnualMileage: state.mileage,
                    },
                    VehicleRequests: [request],
                })
                .then(response => {
                    resolve(response.data.VehicleResults);
                })
                .catch(error => {
                    console.error("getFinanceQuoteForDealership error");
                    console.error(error);
                    reject(error);
                });
        });
    },
    findCheapestQuote({commit, state}) {
        if (state.quotes == null) {
            commit('setMonthlyPayment', null);
            commit('setFinanceType', null);
            commit('setNumberOfPayments', null);
            return;
        }

        let cheapestMonthlyPayment = null, financeType = null, numberOfPayments = null;
        const quotesLength = state.quotes.length;
        for (let index = 0; index < quotesLength; index++) {
            const quote = state.quotes[index];
            if (typeof quote.FinanceProductResults[0] == 'undefined') {
                continue
            }
            const financeProduct = quote.FinanceProductResults[0];
            if (typeof financeProduct.HasError != 'undefined' && financeProduct.HasError == true) {
                continue;
            }
            if (typeof financeProduct.Quote.AllInclusiveRegularPayment == 'undefined' || typeof financeProduct.Quote.NumberOfRegularPayments == 'undefined' || typeof financeProduct.Key == 'undefined') {
                continue;
            }
            if (cheapestMonthlyPayment == null || financeProduct.Quote.AllInclusiveRegularPayment < cheapestMonthlyPayment) {
                cheapestMonthlyPayment = financeProduct.Quote.AllInclusiveRegularPayment;
                financeType = financeProduct.Key;
                numberOfPayments = financeProduct.Quote.NumberOfRegularPayments;
            }
        }

        if (cheapestMonthlyPayment == null) {
            commit('setMonthlyPayment', null);
            commit('setFinanceType', null);
            commit('setNumberOfPayments', null);
            return;
        }
        commit('setMonthlyPayment', cheapestMonthlyPayment);
        commit('setFinanceType', financeType);
        commit('setNumberOfPayments', numberOfPayments);
    },
    setPcpQuote({ commit, state, rootState}) {
        if (state.quotes == null) {
            state.pcpQuote = null;
            return;
        }

        const quotesLength = state.quotes.length;
        let financeProduct = null;
        for (let index = 0; index < quotesLength; index++) {
            const quote = state.quotes[index];
            if (typeof quote['Id'] == 'undefined') {
                continue;
            }
            if (quote.Id != rootState.selectedNewVehicle.id + "-" + 'PCP') {
                continue;
            }
            if (typeof quote.FinanceProductResults[0] == 'undefined') {
                continue
            }
            financeProduct = quote.FinanceProductResults[0];
        }

        if (financeProduct == null) {
            state.pcpQuote = null;
            return;
        }

        if (financeProduct.HasError) {
            state.pcpQuote = null;
            return;
        }

        let quoteArray = [];

        quoteArray.push({
            title: 'Customer Cash Deposit',
            value: '&pound;' + NumberFormat(financeProduct.Quote.CashDeposit, 2)
        });

        if (rootState.selectedNewVehicle.brand == 'peugeot') {
            const dealerDepCon = getDealerDepositContribution(financeProduct);

            if (dealerDepCon == 0) {
                const depCon = getDepositContribution(financeProduct);

                if (depCon > 0) {
                    quoteArray.push({
                        title: GetManufacturerFromBrand(rootState.selectedNewVehicle.brand) + ' Deposit Contribution',
                        value: '&pound;' + NumberFormat(depCon, 2)
                    });
                }
            } else {
                const depConExcludingDealer = getDepositContributionExcludingDealer(financeProduct);
                if (depConExcludingDealer > 0) {
                    quoteArray.push({
                        title: GetManufacturerFromBrand(rootState.selectedNewVehicle.brand) + ' Deposit Contribution',
                        value: '&pound;' + NumberFormat(depConExcludingDealer, 2)
                    });
                }

                quoteArray.push({
                    title: 'Part Exchange Boost*',
                    value: '&pound;' + NumberFormat(dealerDepCon, 2)
                });
            }
        } else {
            const depCon = getDepositContribution(financeProduct);

            if (depCon > 0) {
                quoteArray.push({
                    title: GetManufacturerFromBrand(rootState.selectedNewVehicle.brand) + ' Deposit Contribution',
                    value: '&pound;' + NumberFormat(depCon, 2)
                });
            }
        }

        quoteArray = appendVehiclePricingIncludingApplicableGrants(rootState, quoteArray, financeProduct.Quote);

        const roadsideAssistance = getRoadsideAssistance(financeProduct.Quote);

        const financeName = getFinanceNameFromKey({
            brand: rootState.selectedNewVehicle.brand,
            manufacturer: rootState.selectedNewVehicle.manufacturer,
        }, 'PCP', false);

        if (rootState.selectedNewVehicle.brand !== 'vauxhall') {
            quoteArray.push({
                title: financeName + ' Price<br /><span class="smallText">Including &pound;' + roadsideAssistance + ' Roadside Assistance</span>',
                value: '&pound;' + NumberFormat(financeProduct.Quote.TotalPrice, 2)
            });
        }

        quoteArray.push({
            title: 'Amount Financed',
            value: '&pound;' + NumberFormat(financeProduct.Quote.Balance, 2)
        });

        quoteArray.push({
            title: 'Optional Final Payment To Buy',
            value: '&pound;' + NumberFormat(getFinalPayment(financeProduct.Quote), 2)
        });

        const firstFee = getFirstFee(financeProduct.Quote);

        quoteArray.push({
            title: 'Credit Facility Fee<br /><span class="smallText">Payable With 1st Payment</span>',
            emailTitle: 'Credit Facility Fee - Payable With 1st Payment',
            value: '&pound;' + NumberFormat(firstFee, 2)
        });

        quoteArray.push({
            title: 'Term Of Agreement',
            value: financeProduct.Quote.Term + ' months'
        });

        quoteArray.push({
            title: 'Total Charge For Credit',
            value: '&pound;' + NumberFormat(financeProduct.Quote.TotalChargeForCredit, 2)
        });

        quoteArray.push({
            title: 'Total Amount Of Credit',
            value: '&pound;' + NumberFormat(financeProduct.Quote.AmountOfCredit, 2)
        });

        quoteArray.push({
            title: 'Total Amount Payable',
            value: '&pound;' + NumberFormat(financeProduct.Quote.TotalAmountPayable, 2)
        });

        quoteArray.push({
            title: 'Fixed Rate of Interest',
            value: NumberFormat(financeProduct.Quote.RateOfInterest, 2) + '%'
        });

        if (state.modified) {
            quoteArray.push({
                title: 'APR',
                value: NumberFormat(financeProduct.Quote.Apr, 2) + '%'
            });
        } else {
            quoteArray.push({
                title: 'Representative APR',
                value: NumberFormat(financeProduct.Quote.Apr, 2) + '%'
            });
        }

        quoteArray.push({
            title: 'Excess Mileage Charge',
            value: ' ' + NumberFormat(financeProduct.Quote.ExcessMileageRate,0) + ' pence per mile'
        });

        quoteArray.push({
            title: 'Annual Mileage',
            value: ' ' + NumberFormat(financeProduct.Quote.AnnualMileage,0) + '  miles'
        });

        commit('setPcpQuote', {
            name: financeName,
            monthlyPayment: financeProduct.Quote.AllInclusiveRegularPayment,
            numberOfPayments: numberOfPayments(financeProduct),
            quote: quoteArray,
        });
    },
    setHpQuote({ commit, state, rootState}) {
        if (state.quotes == null) {
            state.hpQuote = null;
            return;
        }

        const quotesLength = state.quotes.length;
        let financeProduct = null;
        for (let index = 0; index < quotesLength; index++) {
            const quote = state.quotes[index];
            if (typeof quote['Id'] == 'undefined') {
                continue;
            }
            if (quote.Id != rootState.selectedNewVehicle.id + "-" + 'HP') {
                continue;
            }
            if (typeof quote.FinanceProductResults[0] == 'undefined') {
                continue
            }
            financeProduct = quote.FinanceProductResults[0];
        }

        if (financeProduct == null) {
            state.hpQuote = null;
            return;
        }

        if (financeProduct.HasError) {
            state.hpQuote = null;
            return;
        }

        let quoteArray = [];
        quoteArray.push({
            title: 'Customer Cash Deposit',
            value: '&pound;' + NumberFormat(financeProduct.Quote.CashDeposit, 2)
        });

        let depCon = getDepositContribution(financeProduct);

        if (depCon > 0) {
            quoteArray.push({
                title: GetManufacturerFromBrand(rootState.selectedNewVehicle.brand) + ' Deposit Contribution',
                value: '&pound;' + NumberFormat(depCon, 2)
            });
        }

        quoteArray = appendVehiclePricingIncludingApplicableGrants(rootState, quoteArray, financeProduct.Quote);

        quoteArray.push({
            title: 'Total Amount Of Credit',
            value: '&pound;' + number_format(financeProduct.Quote.Balance,2),
        });
        quoteArray.push({
            title: 'Term Of Agreement',
            value: financeProduct.Quote.Term + ' months'
        });
        quoteArray.push({
            title: 'Total Charge For Credit',
            value: '&pound;' + number_format(financeProduct.Quote.TotalChargeForCredit,2),
        });
        quoteArray.push({
            title: 'Total Amount Of Credit',
            value: '&pound;' + number_format(financeProduct.Quote.AmountOfCredit,2),
        });
        quoteArray.push({
            title: 'Total Amount Payable',
            value: '&pound;' + number_format(financeProduct.Quote.TotalAmountPayable,2),
        });

        if (this.modified) {
            quoteArray.push({
                title: 'APR',
                value: NumberFormat(financeProduct.Quote.Apr, 2) + '%'
            });
        } else {
            quoteArray.push({
                title: 'Representative APR',
                value: NumberFormat(financeProduct.Quote.Apr, 2) + '%'
            });
        }

        quoteArray.push({
            title: 'Fixed Rate of Interest',
            value: NumberFormat(financeProduct.Quote.RateOfInterest, 2) + '%'
        });

        const financeName = getFinanceNameFromKey({
            brand: rootState.selectedNewVehicle.brand,
            manufacturer: rootState.selectedNewVehicle.manufacturer,
        }, 'HP', false);


        commit('setHpQuote', {
            name: financeName,
            monthlyPayment: financeProduct.Quote.AllInclusiveRegularPayment,
            numberOfPayments: numberOfPayments(financeProduct),
            quote: quoteArray,
        });
    }
};

const mutations = {
    setFinanceTerm(state, value) {
        state.modified = true;
        state.term = cleansePositiveNumber(value, false);
        saveToStorage('new_term', state.term);
    },
    setFinanceDeposit(state, value) {
        state.modified = true;
        state.deposit = cleansePositiveNumber(value, false);
        saveToStorage('new_deposit', state.deposit);
    },
    setFinanceMileage(state, value) {
        state.modified = true;
        state.mileage = cleansePositiveNumber(value, false);
        saveToStorage('new_mileage', state.mileage);
    },
    setFinanceLoading(state, value) {
        state.financeLoading = value;
    },
    setQuotes(state, value) {
        state.quotes = value;
    },
    setFinanceType(state, value) {
        state.financeType = value;
    },
    setMonthlyPayment(state, value) {
        state.monthlyPayment = value;
    },
    setNumberOfPayments(state, value) {
        state.numberOfPayments = value;
    },
    setSelectedDealerCodewaversKey(state, value) {
        state.selectedDealerCodewaversKey = value;
    },
    setPcpQuote(state, quote) {
        state.pcpQuote = quote;
    },
    setHpQuote(state, quote) {
        state.hpQuote = quote;
    },
    setFinanceAvailable(state, financeAvailable) {
        state.financeAvailable = financeAvailable;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};